const isScreen =
  (breakpoints: { [key: string]: boolean } | undefined) =>
  (...sizes: Array<string>) =>
    breakpoints && sizes.some((size) => breakpoints[size]);

export default isScreen;
